var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.5707 4.42975C17.955 2.81299 15.8224 1.99879 13.705 2C11.587 1.99879 9.455 2.81299 7.83932 4.42975C6.22246 6.04534 5.40759 8.17782 5.41005 10.2945C5.40821 11.7733 5.81471 13.254 6.60333 14.5662L2.58643 18.5829C1.80452 19.3647 1.80452 20.6318 2.58643 21.4136C3.36771 22.1955 4.63545 22.1955 5.41673 21.4136L9.43422 17.3964C10.7459 18.1855 12.2273 18.5914 13.705 18.5896C15.8224 18.5914 17.955 17.7772 19.5707 16.1604C21.187 14.5449 22.0018 12.4129 22 10.2945C22.0025 8.17782 21.187 6.04534 19.5707 4.42975ZM17.3056 13.8961C16.3076 14.8934 15.0136 15.3853 13.705 15.3878C12.3964 15.3853 11.103 14.8934 10.1038 13.8961C9.10643 12.897 8.61446 11.6036 8.612 10.2945C8.61446 8.98656 9.10639 7.69264 10.1038 6.69411C11.103 5.69683 12.3964 5.20489 13.705 5.20243C15.0136 5.20489 16.3076 5.69679 17.3062 6.69411C18.3036 7.69264 18.7955 8.98656 18.798 10.2945C18.7955 11.6037 18.3036 12.897 17.3056 13.8961Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSearch);
export default __webpack_public_path__ + "static/media/icon_search.43b60e891bd07e40e9dcc04e97999246.svg";
export { ForwardRef as ReactComponent };